import { createBrowserRouter } from "react-router-dom";

import NotFoundPage from "../pages/NotFoundPage";
import FormBuilderPage from "../pages/FormBuilderPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: <FormBuilderPage />,
    errorElement: <NotFoundPage />,
  },
]);

export default router;
